import { Typography } from '@mui/material';

import { getQuestionnaireSectionLabelSx } from '../styles';

import type { QuestionnaireSectionLabelProps } from '../types';

export default function QuestionnaireSectionLabel({
  variant = 'h5',
  children,
  fontWeight,
  sx,
}: QuestionnaireSectionLabelProps) {
  return (
    <Typography variant={variant} sx={getQuestionnaireSectionLabelSx(fontWeight, sx)}>
      {children}
    </Typography>
  );
}
